import { convertCellList } from '@/common/converter/convert-cell-list'

export const convertCellTopList = async (catalogList = []) => {
  if (catalogList.length <= 0) return

  const [catalog] = catalogList

  if (!catalog) return undefined

  const { elementList = [] } = catalog

  return {
    title_list: [],
    title_img: '',
    title_side: '',
    topbuttonlist: [],
    pagecount: '',
    count: '',
    cell_type: '',
    celllist: await convertCellList(elementList), // home
  }
}
